import React from 'react';
import './DeleteContactsForm.scss';
import { closeDeleteContactsForm } from '../../MainVIew/Contacts/contactsSlice';
import { deleteContact } from '../../Authorization/authSlice';

const DeleteContactsForm = (props) => {
    const { dispatch } = props;
 // CLICK OK
 
 const onSend = () => {
      
    console.log('Start delete contact action');

        const data = {
            userId: props.userId,
            contactId: props.contactId,
        }

        dispatch(deleteContact(data));
       
    
       dispatch(closeDeleteContactsForm());
    }
    
/*
    //ONCLICK DELETE CONTACT
    const onClickDeleteContact = (e) => {
        const selectedId = e.target.value;
        
        console.log('Start delete contact action');
        const data = {
            userId: props.userId,
            contactId: selectedId,
        }

        dispatch(deleteContact(data));
    }

*/
    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeDeleteContactsForm());
    

    }


    const render = () => {
        //console.log(this.props.adminState.openInputForms);
       // this.props.accountState.openClearHistoryForm)
        if (true) {
            return(
                <div className="DeleteContactsForm">
                    
                <p><b>Вы действительно хотите удалить контакт?</b></p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
        } else return null;
   
    }
return render();
}
export default DeleteContactsForm;
  